import z from "zod";

export const maintenanceWorkflowSchema = z.object({
  current_equipment_usage: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  observations: z.string({ message: 'Campo obrigatório' }).min(8, { message: 'Tamanho mínimo: 8 caracteres' }),
  solicitation_ids: z.array(z.string()).min(1, { message: 'Selecione pelo menos uma solicitação' }),
});

export type MaintenanceWorkflowValidationSchema = z.infer<typeof maintenanceWorkflowSchema>;
